import React from 'react';
import * as Styled from './ModalBody.styles';

export const ModalBody = (modalBodyData: ModalBodyComponent) => (
  <Styled.ModalBody isPadded={modalBodyData.isPadded} className={modalBodyData.className}>
    {modalBodyData.children}
  </Styled.ModalBody>
);
